export default {
      id: "ic_large_search_input-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_large_search_input-usage",
      toString: function () {
        return this.url;
      }
    }